import { useEffect, useState } from 'react';

import { autoCreditApi } from '@/integrations/app.api/auto-credit.api';

interface ResponseHistoryInterface {
  result: Array<{
    create_date: string;
    data: {
      body: Record<string, unknown>;
      description: string;
      initiator: string;
    };
  }>;
}

interface HistoryDataInterface {
  createdDate: string;
  description: string;
  initiator: string;
  details: string;
}

interface IProps {
  bank?: string;
  offerId?: string;
  shouldSentRequest: boolean;
}

const useOfferHistory = ({ bank, offerId, shouldSentRequest }: IProps) => {
  const [data, setData] = useState<HistoryDataInterface[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!shouldSentRequest || !offerId || !bank) return;

    (async () => {
      try {
        if (data.length === 0) setLoading(true);
        const response = await autoCreditApi.getOfferHistory<
          ResponseHistoryInterface[]
        >(offerId, bank);
        if (!response?.[0]?.result) return;

        setData(
          response[0].result.map((item) => ({
            createdDate: item.create_date,
            description: item.data.description,
            initiator: item.data.initiator,
            details: JSON.stringify(item.data.body, null, 2)
          }))
        );
      } finally {
        setLoading(false);
      }
    })();
  }, [shouldSentRequest, offerId, bank]);

  return { data, loading };
};

export default useOfferHistory;
